import React, {useState} from 'react';
import axios from 'axios';
import {NotificationManager} from 'react-notifications';
import Navbar from "../parts/Navbar";
import Sidebar from "../parts/Sidebar";
import ControlSidebar from "../parts/ControlSidebar";
import Footer from "../parts/Footer";
import {API_ENDPOINT} from '../config';
import {useAuth} from '../auth/AuthContext';

const ContactPage = () => {
    const {auth, logout} = useAuth();
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [sending, setSending] = useState(false);

    const senderEmail = (() => {
        try {
            const payload = JSON.parse(atob(auth.token.split('.')[1]));
            return payload.username || payload.email || '';
        } catch {
            return '';
        }
    })();

    const handleSubmit = async () => {
        if (subject.trim().length < 3) {
            NotificationManager.warning('Subiectul trebuie să aibă minim 3 caractere.');
            return;
        }
        if (message.trim().length < 10) {
            NotificationManager.warning('Mesajul trebuie să aibă minim 10 caractere.');
            return;
        }
        setSending(true);
        try {
            await axios.post(
                `${API_ENDPOINT}/v1/me/contact`,
                {subject, message},
                {headers: {Authorization: `Bearer ${auth.token}`}}
            );
            NotificationManager.success('Mesajul a fost trimis. Vă mulțumim!');
            setSubject('');
            setMessage('');
        } catch (err) {
            if (err.response?.status === 401) {
                logout();
            } else {
                NotificationManager.error(err.response?.data?.error || 'Nu am putut trimite mesajul.');
            }
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="wrapper">
            <Navbar/>
            <Sidebar/>
            <ControlSidebar/>
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0">Contact</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-md-8 col-lg-6">
                                <div className="card card-outline card-primary">
                                    <div className="card-header">
                                        <h3 className="card-title mb-0">
                                            <i className="fas fa-envelope mr-2"></i>
                                            Trimite un mesaj administratorului
                                        </h3>
                                    </div>
                                    <div className="card-body">
                                        {senderEmail && (
                                            <div className="form-group">
                                                <label>De la</label>
                                                <input type="email" className="form-control" value={senderEmail} disabled/>
                                            </div>
                                        )}
                                        <div className="form-group">
                                            <label>Subiect</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Despre ce este vorba?"
                                                value={subject}
                                                onChange={(e) => setSubject(e.target.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Mesaj</label>
                                            <textarea
                                                className="form-control"
                                                rows={6}
                                                placeholder="Scrieți mesajul dumneavoastră..."
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="card-footer">
                                        <button
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={sending}
                                            onClick={handleSubmit}
                                        >
                                            {sending
                                                ? <><i className="fas fa-spinner fa-spin mr-1"></i> Se trimite…</>
                                                : <><i className="fas fa-paper-plane mr-1"></i> Trimite</>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer/>
        </div>
    );
};

export default ContactPage;
